import { generateMobileSourcesForPicture } from '@farmersdog/corgi-x';

import pawsWithPacksWebPng from './paws-with-packs-original.png';
import pawsWithPacksWebP from './paws-with-packs.webp';
import pawsWithPacksJpg from './paws-with-packs.jpg';

export const pawsWithPacks = generateMobileSourcesForPicture({
  png: pawsWithPacksWebPng,
  jpg: pawsWithPacksJpg,
  webP: pawsWithPacksWebP,
});
